import iviewLocale from 'iview/src/locale/lang/ko-KR';
export default {
    locale: 'ko-KR',
    user:{
        "defaultMenu":"기본 메뉴",
        "pleaseWait":"잠시만 기다려주세요!",
        "role":"역할",
        "title": "람다 플랫폼",
        "subtitle": "람다 플랫폼",
        "login": "로그인",
        "forgot": "비밀번호 찾기",
        "remember": "로그인 상태 유지",
        "loginTitle": "시스템 로그인",
        "username": "사용자 이름",
        "email": "이메일",
        "password": "비밀번호",
        "loginSuccess": "로그인 되었습니다. 잠시만 기다려주세요!",
        "loginError": "죄송합니다. 오류가 발생하였습니다. 다시 시도해주세요!",
        "emailRequired": "이메일을 입력하세요.",
        "emailSendError": "이메일을 보내는 동안 오류가 발생했습니다",
        "forgotDescription": "이메일 입력 후 비밀번호를 재설정해주세요.",
        "sendPasswordResetCode": "비밀번호 재설정 코드 이메일로 받기",
        "passwordConfirm": "비밀번호 확인",
        "userNotFound": "사용자를 찾을 수 없습니다.",
        "codeSentError": "확인 코드 전송 시 오류가 발생하였습니다. 다시 시도해주세요!",
        "passwordReset": "비밀번호 재설정 비밀번호 업데이트",
        "passwordResetCode": "비밀번호 재설정 코드",
        "passwordResetCodeSent": "확인 코드가 전송되었습니다.",
        "passwordResetCodeRequired": "확인 코드가 입력하지 않았습니다!",
        "passwordResetSuccess": "비밀번호가 정상적으로 변경되었습니다!",
        "passwordConfirmError": "비밀번호가 일치하지 않습니다!",
        "passwordResetCodeIncorrect": "확인 코드가 맞지 않습니다. 다시 확인해주세요!",
        "passwordResetCodeTimeout": "시간이 초과되었습니다. 다시 시도해주세요!",
        "noReply": "이 이메일은 자동으로 전송되었으므로 회신할 필요가 없습니다.",
        "databaseview": "데이터베이스, 보기",
        "database": "데이터 베이스",
        "view": "보다",
        "add": "추가하다",
        "characteristics": "형질",
        "basic": "기초적인",
        "column": "열",
        "name": "이름",
        "optional": "부가물",
        "filter": "필터",
        "data": "데이터",
        "save": "저장",
        "tableList": "테이블 목록",
        "aggregation": "집합",
        "sort": "종류",
        "use": "사용하다",
        "grouping": "그룹화",
        "type": "유형",
        "alias": "별명",
        "dataProcessing": "데이터 처리",
        "select": "선택하다",
        "pleaseEnterSearchValue": "검색 값을 입력하십시오",
        "user": "사용자",
        "users": "사용자",
        "totalEmployees": "총 직원",
        "deleted": "삭제됨",
        "searchForInformation": "정보 검색",
        "addUser": "사용자 추가",
        "noData": "데이터 없음",
        "page": "페이지",
        "shows": "보여 주다",
        "categorySearch": "카테고리 검색",
        "image": "영상",
        "lastName": "성",
        "firstName": "이름",
        "registrationNumber": "등록 번호",
        "dateOfBirth": "생일",
        "gender": "성별",
        "men": "남자들",
        "women": "여성",
        "phone": "핸드폰",
        "fillInTheNewOne": "새로운 것을 채우십시오",
        "permission": "허가",
        "loginName": "로그인 이름",
        "confirmPassword": "비밀번호 확인",
        "personalInformation": "개인 정보",
        "changePassword": "비밀번호 변경",
        "settings": "설정",
        "logOut": "로그 아웃",
        "pleaseSelectRole": "역할을 선택하세요.",
        "administraationRightsManagment": "행정권 관리",
        "additional": "추가의",
        "dataSource": "데이터 소스",
        "chart": "차트",
        "userList": "사용자 목록",
        "import": "수입",
        "register": "등록하다",
        "confirm": "확인하다",
        "menuSelection": "메뉴 선택",
        "noMatchingData": "일치하는 데이터가 없습니다",
        "nickName": "별명",
        "note": "메모",
        "pleaseEnterVisibleName": "보이는 이름을 입력하세요",
        "firstNameandLastName": "이름 및 성",
        "mobile": "이동하는",
        "createdDate": "만든 날짜",
        "registrationConfirmed": "등록 확인됨",
        "registrationIsNotConfirmed": "등록이 확인되지 않았습니다",
        "success": "성공적인",
        "systemUpdate": "시스템 업데이트",
        "sendDataStructure": "데이터 구조 보내기",
        "pleaseReEnterYourPassword": "비밀번호를 다시 입력하시겠습니까?",
        "theValueIsRegistered": "값이 등록되었습니다",
        "possibleTableView": '가능한 "테이블" 및 "보기"',
        "table": "테이블",
        "ascending": "오름차순",
        "descending": "내림차순",
        "byLoginName": "로그인 이름으로",
        "dateAdded": "추가된 날짜",
        "inPage": "인페이지",
        "show": "보여 주다",
        "outOf": "총",
        "fromUsers": "사용자로부터",
        "showing": "전시",
        "noInfo":"정보 없음 ",
        "ruconfinfo": "직원 정보 검색에 자신이 있습니까?",
        "ruconfinfoDelete": "직원 정보를 완전히 삭제하시겠습니까?",
        "created": "만들어진",
        "userDeleted": "사용자가 삭제되었습니다.",
        "_logout":"로그 아웃",
        "_cancel":"취소",
        "listOfDeletedUsers": "삭제된 사용자 목록",
        "by": "~에 의해",
        "no":"아니요",
        "yes":"예",
        "completeDestruction": "전파",
        "recovery": "회복",
        "errorOccWhileDeleting": "삭제하는 동안 오류가 발생했습니다.",
        "userInformationRestored": "사용자 정보 복원",
        "errorOccurredWhileRetrievingData": "데이터를 검색하는 동안 오류가 발생했습니다.",
        "total": "합계",
        "edit":"다듬다",
        "pleaseLogInUsingYourRegUnamePassword": "등록하신 아이디와 비밀번호로 로그인해주세요!",
        "frequentlyAskedQuestions": "보편 질문",
        "toContaqt": "연락하다",
        "downloadYourMobileApp": "모바일 앱을 다운로드합니다.",
        "instructionsUse": "사용 지침",
        "hayg": "몽골, 울란바토르 시, 수흐바토르 지구, 9th khoroo, Ikh toiruu 54, Computer Mall, 8층, 8002호",
        "plseResUrPassUsingUrRegisteredEmail": "등록된 이메일 주소를 사용하여 비밀번호를 재설정하세요?",
        "downloadAppHere": "여기에서 앱 다운로드",
        "contact_us":"문의하기",
        "instruction":'지침',
        "hotelReservationPlatform":'호텔 예약 플랫폼',
        "ourPlatform":'우리 플랫폼',
        "multiLanguage":'다중 언어',
        "hotelReservation":'호텔 예약',
    },
    agent_wizard:{
        "confirm_registration_information":"등록 정보 확인",
        "step":"단계",
        "hello":"안녕하십니까 ?",
        "your_name":"당신의 이름",
        "your_last_name":"당신의 성",
        "name_desc":"귀하의 실명은 라틴 또는 몽골어로 최대 75자까지 작성하십시오.",
        "last_name_desc":"성은 라틴어 또는 몽골어로 최대 75자까지 작성하십시오.",
        "your_birthday":"생년월일",
        "your_gender":"당신의 성별",
        "women":"여자",
        "man":"남자",
        "_register": "등록 번호",
        "register_desc": "등록번호를 입력해주세요. 몽골어로만 작성해주세요.",
        "example":"예를 들어",
        "contact_information":"연락처 정보",
        "your_email_address":"귀하의 이메일 주소",
        "email_desc":"당신의 이메일 주소를 입력하십시오. 공백 없이 라틴 문자, 소문자로 작성하십시오.",
        "your_phone_number":"휴대전화 번호",
        "phone_desc":"휴대폰 번호를 입력해주세요. 숫자와 공백만 사용하십시오.",
        "profile_image":"프로필 이미지",
        "profile_image_uploud":"프로필 사진 업로드",
        "profile_desc":"프로필 사진을 선택하여 서버에 업로드하십시오. 이미지 크기는 1MB를 초과할 수 없습니다.",
        "your_new_password":"새 비밀번호",
        "password_desc":"비밀번호는 라틴 문자, 대문자 및 소문자, 숫자, 특수 문자로 공백 없이 입력해야 합니다.",
        "rep_your_new_password":"새 비밀번호를 반복하세요.",
        "_prev":"이전의",
        "_next":"다음",
        "enter_personal_information":"개인정보를 정확하게 입력해주세요!",
        "enter_contact_information":"연락처를 정확하게 입력해주세요!",
        "please_change_your_password":"비밀번호를 변경해주세요! 새 비밀번호는 앞으로 사용됩니다.",
        "please_contact_system_administor":"도움이 필요하면 시스템 관리자에게 문의하세요.",
        "back":"돌아가다",
        "entered_information":"입력한 정보",
        "information_alert":"귀하의 정보를 검토하고 정확한 경우 시스템에 보내주십시오.",
        "no_information":"정보 없음",
        "date_you_added_system":"시스템에 추가된 날짜",
        "send_registration":"등록 보내기",
        "userDeleted":"사용자가 삭제되었습니다.",
        "errorOccurredDeleting":"삭제하는 동안 오류가 발생했습니다.",
        "UserInformationRestored":"사용자 정보 복원.",
        "ErrorRetrievingData":"데이터를 검색하는 동안 오류가 발생했습니다!",
        "NoSearchResultsFound":"검색된 결과가 없습니다!",
        "SpacesAreIncluded":"공간이 포함되어 있습니다.",
    },
    adminModule:{
        "db": "데이터베이스",
        "usersAndUserGroups": "소비자 권리",
        "users": "사용자",
        "userGroupsPermission": "액세스 권한, 권한",
        "sendDBSchema":"데이터베이스 스키마 보내기",
        "AddColumn":"열 추가",
        "systemUpdate":"시스템 업데이트",
        "graphic":"그래픽",
        "column":"열",
        "dataType":"데이터 형식",
        "form":"형태",
        "table":"테이블",
        "original_preparation": "원래 준비",
        "pleaseWait":"잠시만 기다려주세요!",
        "_form":"형태",
        "value_column": "값 열",
        "Custom_column ":"맞춤 열",
        "list_grid": "목록 | 그리드",
        "Judgment_column ":"필터 열",
        "form_value":"형태 (가치를 취하다)",
        "InformationSuccessfullyDistributed":"정보가 성공적으로 배포되었습니다!",
        "InformationReturned":"정보가 반환되었습니다!",
    },
    graphql:{
        "graphqlManagement":"Graphql 관리",
        "table":"테이블",
        "selectTable":"테이블 선택",
        "name": "이름",
        "idField":" ID 필드",
        "hideFields":"필드 숨기기",
        "permissionActions":"권한 작업",
        "add":"추가하다",
        "edit":"편집하다",
        "delete":"삭제",
        "save": "저장",
        "accessAndAccessRights":"접근 및 접근 권한",
        "nevtersenHundHaruulah":"로그인 한 모든 사람에게 보여줍니다.",
        "accessRights":"액세스 권한",
        "allUsersCanSee":"권한이 없는 경우 모든 사용자가 볼 수 있습니다.",
        "subTables":"하위 테이블",
        "subTable":"하위 테이블",
        "connectionField":"연결 필드",
        "tableList": "테이블 목록",
        "viewList": "View 목록",
        "real_time": "실시간 구독",
        "cancel":"취소",
        "tableParentId":"테이블 상위 ID",
        "action":"동작",
    },
    components:{
        "add": "추가하다",
        "pleaseEnterSearchValue": "검색 값을 입력하십시오...",
        "pleaseWait":"잠시만 기다려주세요!",
        "deleteData":"데이터를 삭제하시겠습니까?",
        "name": "이름",
        "yes":"예",
        "no":"아니요",
        "copy":"복사",
        "table":"테이블",
        "basicTable":" 기본 테이블",
        "selectTable":"테이블 선택",
        "applications":"애플리케이션",
        "additions":"추가 사항",
        "logistics":"물류 센터",
        "letter":"그 편지",
        "fileDirectory":"파일 디렉토리",
        "admin":"관리자",
        "systemAdministrator":"시스템 관리자",
        "personalInformation":"개인 정보",
        "settings":"설정",
        "logOut":"로그 아웃",
        "changePassword":"비밀번호 변경",
        "projectList":"프로젝트 목록",
        "table_list":"테이블 목록",
        "ui_builder":"UI 빌더",
        "_form":"형태",
        "someContents":"일부 내용",
        "_cancel":"취소",
    },
    chart:{
        "horizontal_value": "수평 값",
        "groupBy": "그룹화 기준",
        "line": "윤곽",
        "_big": "크기가 큰",
        "_small": "작은",
        "field": "들",
        "settings": "설정",
        "icon": "상",
        "bg_color": "배경색",
        "text_color": "텍스트 색상",
        "link_title": "제목 링크",
        "link": "링크",
        "values": "가치",
        "element_type": "요소 유형",
        "_filter": "필터",
        "_name": "이름",
        "responsible_value": "책임 있는 가치",
        "_save": "저장",
        "enter_name": "이름을 입력하세요...",
        "data_table": "데이터 테이블",
        "selectTable":"테이블 선택",
        "aggregation":"집합",
        "no":"아니요",
        "count":"세다",
        "_max":"최대",
        "_min":"최저한의",
        "_avg":"평균",
        "_sum":"Sum",
        "count_distinct":"카운트 고유",
        "avg_distinct":"평균 고유",
        "sum_distinct":"합계 구별",
        "_sort":"정렬",
        "no_sort":"정렬하지 않음",
        "grouping":"그룹화",
        "_type":"유형",
        "fictitious_name":"가상의 이름",
        "_color":"색상",
    },
    dataForm:{
        "save":"저장",
        "pleaseWait":"잠시만 기다려주세요!",
        "fillInTheNewOne": "새로운 것을 채우십시오",
        "close":"닫다",
        "basicSettings":"기본 설정",
        "configureTheData":"데이터 구성",
        "trigger":"방아쇠",
        "informationLink":"정보 링크",
        "GetValuesFromTheTable":"테이블에서 값 가져오기",
        "Geographic":"지리적",
        "AdditionalValues":"추가 값",
        "selectMultipleImg":"여러 이미지를 선택할지 여부",
        "TypeOfTheEditor":"편집기 유형",
        "Placeholder":"자리 표시자",
        "default_Value":"기본값",
        "Get_value_parameter":"매개변수에서 값 가져오기",
        "Parameter_name":"매개변수 이름",
        "Get_user_ID":"사용자 ID 가져오기",
        "Consolidation_formula":"연결 공식",
        "Whether_to_summarize":"요약할지 여부",
        "Choose_a_formula":"공식을 선택하다",
        "Formula_type":"수식 유형",
        "Take_the_word_before_merger":"합병 전에 단어을 받다면",
        "example":"예를 들어",
        "total":"합계",
        "number":"숫자",
        "ets":"등등",
        "Symbol":"상징",
        "get_sign_after_merger":"합병 후 심볼을 얻은 경우",
        "Verification_conditions":"점검 조건",
        "Form_of_data_verification":"데이터 확인 형식",
        "Password_settings":"비밀번호 설정",
        "Password_verification":"비밀번호 확인",
        "_pass":"비밀번호",
        "Create_a_password":"비밀번호 만들기",
        "Check_password_during_editing":"편집 중 비밀번호 확인",
        "number_precision":"침대 정확도",
        "Whether_get_values_database":"데이터베이스에서 값을 가져올지 여부",
        "Choose_multiple_values":"여러 값 선택",
        "value":"의미",
        "visible_word":"보이는 단어",
        "add":"추가하다",
        "table":"테이블",
        "selectTable":"테이블 선택",
        "Related_fields":"관련 분야",
        "Visible_fields":"보이는 필드",
        "Select_fields":"필드 선택",
        "Sort_field":"정렬 필드",
        "Father_column":"부모 아이디",
        "form":"의 형태의",
        "this_table ":"이 테이블",
        "Display_Add_Data_button ":"데이터 추가 버튼 표시",
        "Add_data_Fort ":"데이터 포트 추가",
        "List_of_tables ":"테이블 목록",
        "Link_terms ":"링크 조건",
        "Get_customer ":"고객으로부터 받기",
        "Custom_column ":"맞춤 열",
        "Judgment_column ":"필터 열",
        "Call_from_server":"서버에서 호출",
        "data_loading_URL":"데이터 로딩 URL",
        "Trigger_load_time":"트리거 로드 시간",
        "Example_data_returned_server":"서버에서 반환된 데이터의 예",
        "Successful":"성공적인",
        "URL_call_information_link":"정보 링크를 호출하는 URL",
        "Value_table":"의미 파악 테이블",
        "Value_return_field":"값 반환 필드",
        "Geographic_settings":"지리적 설정",
        "attribute":"기인하다",
        "properties":"속성",
        "Geometric_type":"기하학적 유형",
        "point":"점",
        "line":"선",
        "polygon":"다각형",
        "length_center":"중심의 길이",
        "latitude_center":"중심의 위도",
        "Map_magnification":"지도 확대",
        "Background_map":"배경 지도",
        "Google_Street":"구글 스트리트",
        "Google_Space":"구글 스페이스",
        "Open_Street_Map":"거리 지도 열기",
        "Check_overlap_area":"영역의 겹침 확인",
        "Feature_Class_link":"Feature class 링크",
        "Search_field":"검색 분야",
        "Search_value_field":"검색 값 필드",
        "Success_message":"성공 메시지",
        "Error_message":"에러 메시지",
        "Form_name":"형태 이름",
        "Form_type":"형태 유형",
        "Simple_form":"간단한 형태",
        "Step_by_step_form":"단계별 형태",
        "data_table": "데이터 테이블",
        "idField":" ID 필드",
        "Date_generated_automatically":"자동으로 생성된 날짜",
        "render_by_tab":"탭별 섹션 렌더링",
        "Label_location":"라벨 위치",
        "Form_width":"형태 너비",
        "Save_button_word":"버튼 단어 저장",
        "Padding_spacing":"Padding - 간격",
        "model":"모형",
        "displayName":"외모 이름",
        "hide": "숨기다",
        "inactive": "비활성",
        "translation": "번역",
        "formula": "공식",
        "userInterface": "사용자 인터페이스",
        "_subform": "서브폼",
        "_form": "형태",
        "formula_conditions": "공식, 조건",
        "field": "영역",
        "basic_from": "기본 형태",
        "conditions": "정황",
        "add_a_field": "필드 추가",
        "controller_namespace": "컨트롤러 네임스페이스",
        "namespace": "네임스페이스",
        "before_insert": "추가하기 전에",
        "after_insert": "추가 후",
        "before_update": "업데이트 전",
        "after_update": "업데이트 후",
        "_type":"유형",
        "_top":"맨 위",
        "_left":"왼쪽",
        "Choose_type":"유형 선택",
        "min_height":"최소 높이",
        "Close_deletion_action":"삭제 작업 닫기",
        "close_add_ons_action":"추가 기능 닫기",
        "row_numbering":"어깨 번호 매기기",
        "Use_table_type":"테이블 유형 사용",
        "Table_Type_field":"테이블 유형 필드",
        "Table_Type_value":"테이블 유형 값",
        "Consolidation_forms_and_tables":"형태 및 테이블 통합",
        "_link":"링크",
        "iframe_page":"iframe 페이지",
        "No_action":"조치 없음",
        "_division":"나누다",
        "menuType": "메뉴 종류",
        "connectionPath": "연결 경로",
        "name": "이름",
        "target": "과제",
        "self": "자기",
        "blank": "공백",
        "_new": "새로운",
        "Get_name": "이름을 얻다",
        "section_add":"섹션 추가",
        "add_column":"열 추가",
        "_delete":"삭제",
        "_move":"운반",
        "graphicsManagement": "그래픽 관리",
        "viewPhotos": "사진 보기",
        "createNumber": "번호 만들기",
        "other": "외",
        "download": "다운로드",
        "view": "쳐다보다",
        "pleaseSelectFile": "파일을 선택하세요",
        "longitude": "경도",
        "latitude": "위도",
        "cancel": "취소",
        "enterCoordinatesPressEnter": "좌표를 입력하고 'Enter' 키를 누릅니다?",
        "clickHereSelectPhoto": "사진을 선택하려면 여기를 클릭하세요!",
        "notFound": "찾을 수 없음",
        "confirmPassword": "비밀번호 확인",
        "currentPassword": "현재 비밀번호",
        "pleaseWriting": "써주세요",
        "fromCityCenter": "도심에서",
        "please_enter_value": "값을 입력하세요",
        "formInformationSavedSuccessfully": "양식 정보가 성공적으로 저장되었습니다.",
        "please_enter_formula": "수식을 입력하세요.",
        "savedSuccessfull": "공적으로 저장 되었음",
        "errorSaving": "저장하는 동안 오류가 발생했습니다!",
        "formIformationSavedSuccessfull": "양식 정보가 성공적으로 저장되었습니다.",
        "successDeleted": "성공적으로 삭제되었습니다!",
        "selectDefaultMenu": "기본 메뉴 선택",
        "selectMenu": "메뉴를 선택해주세요",
        "pleaseEnterPasswordYouUCurrentlyUsing": "현재 사용 중인 비밀번호를 입력하세요.",
        "pleaseReEnterYourPassword": "비밀번호를 다시 입력하시겠습니까?",
        "passwordConfirmError": "비밀번호가 일치하지 않습니다!",
        "informationIsIncomplete": "정보가 불완전합니다",
        "trRMandatoryFieldsFillInformationLookFormAFillRequiredFieldsWithRedBorder": "정보를 입력해야 하는 필수 필드가 있습니다. 양식을 보고 빨간색 테두리가 있는 필수 필드를 채우십시오!",
        "successfullySaved": "성공적으로 저장되었습니다.",
        "pleaseDeleteSubDForm": "서브폼을 삭제해주세요",
        "thereZNoRightChangeInformation": "정보를 변경할 권리가 없습니다",
        "enterCoordinatesCorrectly": "좌표를 정확하게 입력하세요",
        "error": "오류",
        "theSiteHasNotBeenSelected": "사이트가 선택되지 않았습니다",
        "noSiteFound": "사이트를 찾을 수 없습니다",
        "dataNotFound": "데이터가 선택되지 않음",
        "pleaseCompleteFirstLine": "첫 번째 줄을 완성해주세요",
        "search": "찾다",
        "values": "가치",
    },
    dataGrid:{
        "infoCourt":"정보 법원",
        "filtering":"필터링",
        "ruSureYouDeleteInfo":"이 정보를 삭제하시겠습니까?",
        "yes":"예",
        "no":"아니요",
        "total":"총계",
        "updateDataFromExcelFile":"Excel 파일에서 데이터 업데이트",
        "default_Value":"기본 값",
        "methodOfComparison": "비교 방법",
        "parameterComparison": "매개변수 비교",
        "whetherLookSidebarSearch": "사이드바 검색에서 볼지 여부",
        "dataLink": "데이터 링크",
        "data_settings": "데이터 설정",
        "basicSettings":"기본 설정",
        "selectTable":"테이블 선택",
        "table": "테이블",
        "tableList": "테이블 목록",
        "Related_fields":"관련 분야",
        "Visible_fields":"보이는 필드",
        "Select_fields":"필드 선택",
        "Select_field":"필드 선택",
        "Sort_field":"정렬 필드",
        "Father_column":"부모 ID",
        "Link_terms ":"링크 조건",
        "inSearch ":"판단에",
        "this_table ":"이 테이블",
        "Get_customer ":"사용자로부터 받기",
        "custom_column": "사용자 열",
        "judgment_column": "필터 열",
        "viewList": "목록 보기",
        "image": "사진",
        "values": "가치",
        "visible_word":"눈에 보이는 단어",
        "add": "추가하다",
        "linkSettings": "링크 설정",
        "insertList": "링크 삽입",
        "linkIcon": "아이콘 링크",
        "showOnlyIcon": "아이콘만 표시",
        "pinColumn": "핀 컬럼",
        "linkType": "링크 유형",
        "pinPosition": "핀 위치",
        "onLeft": "왼쪽에",
        "onRight": "오른쪽으로",
        "radioSettings": "라디오 설정",
        "additionalSettings": "추가 세팅",
        "comparativeValue": "비교 가치",
        "icon": "상",
        "colorCode": "색상 코드",
        "easyEdit": "쉬운 편집",
        "copy":"복사",
        "view": "보는 힘",
        "columnFilterButton": "열 필터 버튼",
        "displayTableFrame": "테이블 프레임 표시",
        "displayMenuColumn": "열에 메뉴 표시",
        "showFullText": "전체 텍스트 표시",
        "reboot": "재부팅",
        "download": "다운로드",
        "pleaseSelectFile": "파일을 선택하세요",
        "excelUpload": "엑셀 업로드",
        "exportExcel": "엑셀 파일 내보내기",
        "landScape": "수평의",
        "portrait": "세로",
        "paperSize": "용지 크기",
        "print": "인쇄",
        "saveSearch": "검색 저장",
        "pivotTool": "피벗 도구",
        "clientRender": "클라이언트 렌더링",
        "numbered": "번호가 매겨진",
        "comparisonModel": "비교 모델",
        "selectSameValues": "동일한 값 선택",
        "multipleLinesChooseFrom": "선택할 수 있는 여러 줄",
        "width": "너비",
        "staticWidth": "정적 너비",
        "destroyedCanBeRestored": "파괴된 것을 복구할 수 있습니다",
        "paging": "페이징",
        "edit":"편집하다",
        "name": "이름",
        "basic": "기초적",
        "basicTable":"기본 테이블",
        "idField":" ID 필드",
        "data_table": "데이터 테이블",
        "pleaseWait":"잠시만 기다려주세요!",
        "save": "저장",
        "appearanceName":"외모 이름",
        "hide":"숨다",
        "court":"법원",
        "searchResults":"검색 결과",
        "translation":"번역",
        "tobePublished":"출판 예정",
        "updateSelectedLineData":"선택한 라인 데이터 업데이트",
        "whenEnteringDataFromExcelFile":"엑셀 파일에서 데이터를 입력할 때",
        "Filtersettings":"필터 설정",
        "excel":"엑셀",
        "model":"패션",
        "updateSelectedLineDataSettings":"선택한 라인 데이터 설정 업데이트",
        "fieldName":"벌판 이름",
        "buttonName":"버튼 이름",
        "updateAndReboot":"업데이트 및 재부팅",
        "countingAssociatedInfo":"관련 정보 계산",
        "relatedTable":"관련 테이블",
        "relatedFields":"관련 분야",
        "fatherField":"부모 아이디",
        "consolidationFormulas":"통합 및 공식",
        "formula":"공식",
        "resultsStorageArea":"결과 저장 영역",
        "consolidation":"통합",
        "consolidationType":"통합 유형",
        "consolidationFormula":"통합 공식",
        "conditionTrigger":"조건 및 트리거",
        "beforeCallingFromDatabase":"데이터베이스에서 호출하기 전에",
        "afterCallingFromDatabase":"데이터베이스에서 호출한 후",
        "beforeDeleting":"삭제하기 전에",
        "afterDeleting":"삭제 후",
        "beforePrinting":"인쇄하기 전에",
        "spreadsheetForm":"스프레드시트 형식",
        "fromType":"양식 유형",
        "update":"업데이트됨",
        "post":"게시",
        "editable_UpdateLink":"편집 가능 - 링크 업데이트",
        "fixEntireLine":"전체 라인 수정",
        "switchEditMode":"편집 모드로 전환",
        "withOneClick":"한 번의 클릭으로",
        "highlightChanges":"하이라이트 변경",
        "saveChangesBulk":"변경 사항을 일괄 저장",
        "gbExcelImport":"Excel import",
        "appearance":"사용자 인터페이스",
        "dataTable":"데이터 테이블",
        "filter":"필터",
        "mini":"미니",
        "simple":"단순한",
        "size": "크기",
        "controllerNameSpace": "가능한 관리 조치",
        "namespace": "네임스페이스",
        "BeforeFetch": "가져오기 전",
        "AfterFetch": "가져오기 후",
        "Symbol":"상징",
        "type": "유형",
        "nickName": "닉네임",
        "filtersAndSelectedLineSettings" : "필터 및 선택한 회선 설정",
        "sort": "활자 한 벌",
        "column": "열",
        "delete":"삭제",
        "actions": "행위",
        "firstColumn": "첫 번째 열",
        "buttonEdit": "버튼 편집",
        "doubleClicktoEdit": "편집하려면 두 번 클릭",
        "actionsField": "작업 필드",
        "performActionWithMouse": "마우스로 작업 수행",
        "renew": "업데이트",
        "tableHeaderTemplate": "테이블 헤더 템플릿",
        "createHeaderTemplate": "헤더 템플릿 만들기",
        "addLine": "라인 추가",
        "addLineBelow": "아래에 한 줄 추가",
        "deleteThisLine": "이 줄을 삭제하시겠습니까?",
        "addColumnAfterThisColumn": "이 열 뒤에 열 추가",
        "pleaseDeleteThisCell": "이 셀을 삭제하십시오",
        "checkModel": "모델 확인",
        "height": "키",
        "widthu": "너비",
        "row": "열",
        "selectPaperSize": "용지 크기 선택",
        "currencySelection": "통화 선택",
        "tugrug": "투그릭",
        "dollar": "달러",
        "euro": "유로",
        "yen": "일본 엔",
        "austDollar": "호주 달러",
        "rubli": "루블",
        "choosevalue": "값 선택",
        "pleaseWaitForLoading": "로딩을 기다려주세요",
        "successfullySaved": "성공적으로 저장되었습니다.",
        "formInformationSavedSuccessfully.": "양식 정보가 성공적으로 저장되었습니다.",
        "anErrorOccurredWhileSaving": "저장하는 동안 오류가 발생했습니다!",
        "successfullyDeleted": "성공적으로 삭제되었습니다!",
        "makeExcel": "엑셀을 만들어라",
        "plseEnterValue": "값을 입력하세요",
        "updatedSuccessfully": "업데이트됨",
        "infoDeleted": "삭제된 정보",
        "tableDataHasBeenSuccessfullyEdited": " 테이블 데이터가 성공적으로 편집되었습니다.",
        "formInfoSavedSuccessfully": "  양식 정보가 성공적으로 저장되었습니다.",
        "errorOccurredWhileUpdating": " 업데이트하는 동안 오류가 발생했습니다.",
        "pleaseSelectUpdateLine": " 업데이트 라인을 선택하세요.",
        "errorOccWhileDeleting": "삭제하는 동안 오류가 발생했습니다.",
        "errorMsg":"죄송합니다, 오류가 발생했습니다",
        "noChangesHaveBeenReported":"보고된 변경 사항이 없습니다.",
    },
    dataSource:{
        "database": "데이터 베이스",
        "add": "추가하다",
        "view": "쳐다보다",
        "pleaseEnterSearchValue": "검색 값을 입력하십시오...",
        "pleaseWait":"잠시만 기다려주세요!",
        "deleteData":"데이터를 삭제하시겠습니까?",
        "yes":"예",
        "no":"아니요",
        "dataProcessing": "데이터 처리",
        "characteristics": "형질",
        "basic": "기초적인",
        "column": "열",
        "name": "이름",
        "additional": "추가의",
        "filter": "필터",
        "data": "데이터",
        "save": "저장",
        "tableList": "테이블 목록",
        "viewList": "View 목록",
        "aggregation": "합치다",
        "sort": "종류",
        "noSort": "정렬하지 않음",
        "use": "사용하다",
        "grouping": "그룹화",
        "type": "유형",
        "alias": "가공적 이름",
        "select": "선택",
        "bolomjitTableAndView":"사용 가능한 'table' 및 'view'",
        "selectTable":"테이블 선택",
        "applications":"애플리케이션",
        "errorOccurredWhileSaving":"저장하는 동안 오류가 발생했습니다!",
    },
    role:{
        "administraationRightsManagment": "행정권 관리",
        "welcome":"어서 오십시오!",
        "loggedIn":"로그인",
        "personalInfo":"개인 정보",
        "changePass":"비밀번호 변경",
        "superAdminManagement":"최고 관리자 관리",
        "logout":"로그 아웃",
        "pleaseWait":"잠시만 기다려주세요!",
        "add": "추가하다",
        "pleaseSelectRole": "역할을 선택하세요?",
        "role":"직장",
        "additional": "추가의",
        "dataSource": "데이터 소스",
        "userList": "사용자 목록",
        "import": "수입",
        "register": "등록하다",
        "confirm": "확인하다",
        "save": "저장",
        "menuSelection": "메뉴 선택",
        "possibleTableView": '가능한 "테이블" 및 "보기"',
        "table": "테이블",
        "name": "이름",
        "displayName": "외모 이름",
        "note":"말",
        "cancel":"취소",
        "defaultMenu":"기본 메뉴",
        "chart":"차트",
        "tableName":"테이블 제목",
        "table_name":"Table 이름",
    },
    project:{
        "project": "프로젝트",
        "settings":"설정",
        "data_recording_environment":"데이터 기록 환경",
        "_form": "형태",
        "table": "테이블",
        "form_and_table_consolidation": "양식 및 스프레드시트",
        "data_processor": "데이터 프로세서",
        "_chart": "차트",
        "original_preparation": "원래 준비",
        "analysis": "분석",
        "target_statement": "목표문",
        "graphql_management": "Graphql 관리",
        "menu": "메뉴",
        "menu_settings":"메뉴 설정",
        "data_settings": "데이터 설정",
        "project_key": "프로젝트 키",
        "server_languege_framework": "서버 언어 및 프레임워크",
        "create_using": "사용하여 생성",
        "download_create_file": "파일 다운로드 및 생성",
        "lambda": "람다",
        "lambda_cli": "람다 CLI",
        "lambda_example_app": "람다 예시 앱",
        "l_key": "키",
        "create": "창조하다",
        "lambda_settings": "람다 설정",
        "laravel_framework": "PHP: 라라벨 프레임워크",
        "go_framework": "Go: 에코 프레임워크",
        "database": "데이터 베이스",
        "database_connect": "데이터베이스 연결",
        "ready": "준비가 된",
        "_success": "나는 당신에게 성공을 기원합니다",
        "type": "유형",
        "manage_access_rights":"접근 권한 관리",
        "add":"추가하다",
        "menuSelection": "메뉴 선택",
        "default_menu": "기본 메뉴",
        "lambda_platform": "작곡가 만들기 프로젝트 람다 플랫폼/라라벨",
        "composer": "작곡가",
        "_save": "저장",
        "optional":"부가물",
        "data_source": "데이터 소스",
        "_moqup": "모쿱",
        "user_list": "사용자 목록",
        "_import": "수입",
        "register": "등록하다",
        "_confirm": "확인 하다",
        "deleteData":"데이터를 삭제하시겠습니까?",
    },
    puzzle:{
        "manage_access_rights":"접근 권한 관리",
        "data_recording_environment":"데이터 기록 환경",
        "_form": "형태",
        "table": "테이블",
        "form_and_table_consolidation": "양식 및 스프레드시트",
        "data_processor": "데이터 프로세서",
        "data_settings": "데이터 설정",
        "_chart": "차트",
        "original_preparation": "원래 준비",
        "_report": "보고서",
        "analysis": "분석",
        "target_statement": "목표문",
        "graphql_management": "Graphql 관리",
        "usersAndUserGroups": "소비자 권리",
        "users": "사용자",
        "userGroupsPermission": "액세스 권한, 권한",
        "menu_settings":"메뉴 설정",
        "logOut": "로그 아웃",
        "cancel":"취소",
        "please_wait":"잠시만 기다려주세요!",
        "add":"추가하다",
        "_save":"저장",
        "optional":"선택 과목",
        "duties":"직장",
        "_name": "이름",
        "appearance_name": "외모 이름",
        "note": "메모",
        "please_select_role": "역할을 선택하세요.",
        "data_source": "데이터 소스",
        "_moqup": "모쿱",
        "user_list": "용자 목록",
        "_import": "수입",
        "default_menu": "기본 메뉴",
        "register": "등록하다",
        "_confirm": "확인하다",
        "list_grid": "목록 | 그리드",
        "custom_column": "맞춤 열",
        "judgment_column": "판정란",
        "value_column": "값 열",
        "delete_data": "데이터를 삭제해주세요",
        "menuSelection": "메뉴 선택",
        "not_found": "찾을 수 없음",
        "meaningTake": "취하다의 의미",
        "filter": "필터",
    },
    notify:{
        "notice": "공지사항",
        "no_notice": "아직 공지가 없습니다!",
        "view_all_notifications": "모든 알림 보기",
    },
    appAdmin: {
        "manual": "설명서",
        "logOut": "로그 아웃",
        "cancel": "취소",
        "add": "추가하다",
        "minus": "마이너스",
        "pleaseWait": "잠시만 기다려주세요!",
        "pleaseEnterSearchValue": "검색 값을 입력하십시오...",
        "delete_data": "데이터를 삭제하시겠습니까?",
        "no": "아니요",
        "yes": "예",
        "settings": "설정",
        "menu_location": "메뉴 위치",
        "stepped": "계단식",
        "stepped_small": "작은 계단",
        "decomposes": "분해",
        "cross": "가로질러",
        "color_selection": "색상 선택",
        "dark_mode": "다크 모드",
        "bright_mode": "환하다 모드",
        "description": "경로 정보를 올바르게 얻기 위해 에이전트를 추가할 때 위에서 아래로 원하는 위치를 입력하시겠습니까?",
        "data_processor": "데이터 프로세서",
        "original_preparation": "원래 준비",
        "dataProcessing": "데이터 처리",
        "graphics_generator": "그래픽 생성기",
        "point": "점",
    },
    moqup:{
        "elements":"집단",
        "chart":"차트",
        "save": "저장",
        "embedlink": "링크 삽입",
        "edit":"편집하다",
        "phone":"핸드폰",
        "tablet":"태블릿",
        "computer":"컴퓨터",
        "bigComputer":"큰 컴퓨터",
    },
    page:{
        "pageNotFound": "페이지를 찾을 수 없습니다.",
    },
    alertMessage:{
        "anErrorOccurredWhileSaving": "저장하는 동안 오류가 발생했습니다!",
        "successfullyDeleted": "성공적으로 삭제되었습니다!",
        "plseEnterValue": "값을 입력하세요",
        "updatedSuccessfully": "업데이트됨",
        "infoDeleted": "삭제된 정보",
        "savedSuccessfull": "공적으로 저장 되었음",
        "confirm": "확인하다",
        "errorOccurredWhileUpdating": " 업데이트하는 동안 오류가 발생했습니다.",
        "pleaseSelectUpdateLine": " 업데이트 라인을 선택하세요.",
        "noChangesHaveBeenReported":"보고된 변경 사항이 없습니다.",
        "pleaseWait":"잠시만 기다려주세요!",
        "pageNotFound": "페이지를 찾을 수 없습니다.",
        "userDeleted": "사용자가 삭제되었습니다.",
        "errorOccWhileDeleting": "삭제하는 동안 오류가 발생했습니다.",
        "userInformationRe": "사용자 정보 복원",
        "errorRetriev": "데이터를 검색하는 동안 오류가 발생했습니다!",
        "notFound": "검색된 결과가 없습니다!",
        "imformation_registered": "귀하의 정보가 성공적으로 등록되었습니다. 잠시만 기다려주세요",
        "errorServer": "서버에서 오류가 발생했습니다",
        "errorSendingMail": "이메일을 보내는 동안 오류가 발생했습니다",
        "please_enter_value": "값을 입력하세요",
        "formInformationSavedSuccessfully": "양식 정보가 성공적으로 저장되었습니다.",
        "please_enter_formula": "수식을 입력하세요.",
        "errorSaving": "저장하는 동안 오류가 발생했습니다!",
        "formIformationSavedSuccessfull": "양식 정보가 성공적으로 저장되었습니다.",
        "successDeleted": "성공적으로 삭제되었습니다!",
        "selectDefaultMenu": "기본 메뉴 선택",
        "selectMenu": "메뉴를 선택해주세요",
        "please_wait":"잠시만 기다려주세요!",
        "form_value":"형태 (가치를 취하다)",
        "alertSelectColumns":"적절한 열 선택",
        "errorMsg":"죄송합니다, 오류가 발생했습니다",
    },
    crud:{
        "registration_history": "등록 내역",
        "Information_viewing_history": "정보 열람 이력",
        "_add": "추가하다",
        "_save": "저장",
        "re_call": "다시 전화하세요",
        "_print": "인쇄",
        "download_file": "엑셀 파일로 다운로드",
    },
    i: {...iviewLocale.i}
}
